import { createMuiTheme } from '@material-ui/core/styles';
import { colors, opacity } from './customColors';
import * as color from './customThemeColors';

const theme = createMuiTheme();

const defaultConfig = {
  props: {
    MuiButton: {
      variant: 'contained',
    },
  },
  shape: {
    borderRadius: 8,
  },
  palette: {
    primary: {
      main: color.turquoiseAndLightGrey.background,
      contrastText: color.turquoiseAndLightGrey.text,
    },
    secondary: {
      main: color.darkTurquoiseAndLightGrey.background,
      contrastText: color.darkTurquoiseAndLightGrey.text,
    },
    success: {
      main: colors.green,
    },
    error: {
      main: colors.red,
    },
    text: {
      primary: colors.darkTurquoise,
      secondary: opacity(colors.darkTurquoise),
    },
    action: {
      disabled: color.disable(color.turquoiseAndLightGrey, 1.0).text,
      disabledBackground: color.disable(color.turquoiseAndLightGrey).background,
    },
  },
  overrides: {
    MuiListSubheader: {
      root: {
        color: colors.darkTurquoise,
      },
      sticky: {
        backgroundColor: colors.lighterBlue,
      },
    },
    MuiTableCell: {
      root: {
        borderBottom: 'none',
        fontSize: '0.75rem', // 12px
      },
      sizeSmall: {
        padding: '6px 16px',
      },
      head: {
        lineHeight: 'initial',
        textTransform: 'uppercase',
        backgroundColor: colors.lighterBlue,
        '&:first-child': {
          borderRadius: theme.spacing(1, 0, 0, 0),
        },
        '&:last-child': {
          borderRadius: theme.spacing(0, 1, 0, 0),
        },
      },
      stickyHeader: {
        backgroundColor: colors.lighterBlue,
      },
    },
    MuiTablePagination: {
      root: {
        backgroundColor: colors.lighterBlue,
        borderRadius: theme.spacing(0, 0, 1, 1),
      },
    },
    MuiIconButton: {
      root: {
        '&$disabled': {
          color: '#e0e0e0',
        },
      },
    },
    MuiChip: {
      root: {
        color: colors.darkTurquoise,
        backgroundColor: colors.yellow,
      },
      sizeSmall: {
        height: 18,
      },
      labelSmall: {
        fontSize: '0.6rem', // 10px
      },
    },
    MuiTabs: {
      root: {
        color: colors.darkTurquoise,
        backgroundColor: colors.lighterBlue,
      },
    },
    MuiTab: {
      root: {
        fontWeight: 500,
        borderWidth: 'thin',
        borderStyle: 'outset',
        borderBottomColor: 'transparent',
        borderRadius: theme.spacing(1, 1, 0, 0),
        backgroundColor: colors.lighterBlue,
      },
      textColorInherit: {
        '&$selected': {
          backgroundColor: colors.lightBlue,
          opacity: 1,
        },
      },
    },
    PrivateTabIndicator: {
      colorSecondary: {
        backgroundColor: colors.yellow,
      },
    },
    MuiExpansionPanelSummary: {
      root: {
        borderRadius: 8,
      },
    },
    MuiListItem: {
      root: {
        '&$selected': {
          backgroundColor: opacity(colors.yellow, 0.12),
        },
      },
    },
    MuiTableRow: {
      root: {
        '&$selected': {
          backgroundColor: opacity(colors.yellow, 0.12),
        },
      },
    },
    MuiPickersDay: {
      current: {
        backgroundColor: colors.lighterBlue,
      },
    },
  },
  typography: {
    h1: {
      fontSize: '70pt',
      fontWeight: 900,
    },
    h2: {
      fontWeight: 900,
    },
    h3: {
      fontFamily: ('Roboto', 'Nunito'),
      fontSize: '1.75rem', // 28px
      fontWeight: 700,
    },
    h4: {
      fontFamily: ('Roboto', 'Nunito'),
      fontSize: '1.5rem', // 24px
      fontWeight: 700,
    },
    h5: {
      fontFamily: ('Roboto', 'Nunito'),
      fontSize: '1rem',
      fontWeight: 700,
    },
    h6: {
      fontSize: '0.875rem', // 14px
      fontWeight: 700,
    },
    subtitle1: {
      fontSize: '0.875rem', // 14px
      fontWeight: 500,
    },
    subtitle2: {
      fontSize: '0.75rem', // 12px
      fontWeight: 500,
    },
    body1: {
      fontSize: '0.875rem', // 14px
    },
    body2: {
      fontSize: '0.75rem', // 12px
    },
    caption: {
      fontSize: '0.6rem', // 10px
    },
    button: {
      textTransform: 'none',
      fontWeight: 400,
    },
  },
};

const defaultTheme = createMuiTheme(defaultConfig);

export const theme2 = createMuiTheme({
  ...defaultConfig,
  palette: {
    ...defaultConfig.palette,
    primary: {
      main: color.darkTurquoiseAndLightGrey.background,
      contrastText: color.darkTurquoiseAndLightGrey.text,
    },
    secondary: {
      main: color.coralAndDarkTurquoise.background,
      contrastText: color.coralAndDarkTurquoise.text,
    },
    action: {
      disabled: color.disable(color.darkTurquoiseAndLightGrey, 1.0).text,
      disabledBackground: color.disable(color.darkTurquoiseAndLightGrey)
        .background,
    },
  },
});

export const theme3 = createMuiTheme({
  ...defaultConfig,
  palette: {
    ...defaultConfig.palette,
    primary: {
      main: color.coralAndDarkTurquoise.background,
      contrastText: color.coralAndDarkTurquoise.text,
    },
    secondary: {
      main: color.turquoiseAndLightGrey.background,
      contrastText: color.turquoiseAndLightGrey.text,
    },
    action: {
      disabled: color.disable(color.coralAndDarkTurquoise).text,
      disabledBackground: color.disable(color.coralAndDarkTurquoise).background,
    },
  },
});

export const theme4 = createMuiTheme({
  ...defaultConfig,
  palette: {
    ...defaultConfig.palette,
    primary: {
      main: color.darkTurquoiseAndLightGrey.background,
      contrastText: color.darkTurquoiseAndLightGrey.text,
    },
    secondary: {
      main: color.yellowAndDarkTurquoise.background,
      contrastText: color.yellowAndDarkTurquoise.text,
    },
    action: {
      disabled: color.disable(color.darkTurquoiseAndLightGrey, 1.0).text,
      disabledBackground: color.disable(color.darkTurquoiseAndLightGrey)
        .background,
    },
  },
});

export const theme5 = createMuiTheme({
  ...defaultConfig,
  palette: {
    ...defaultConfig.palette,
    primary: {
      main: color.lightBlueAndDarkTurquoise.background,
      contrastText: color.lightBlueAndDarkTurquoise.text,
    },
    secondary: {
      main: color.darkTurquoiseAndLightGrey.background,
      contrastText: color.darkTurquoiseAndLightGrey.text,
    },
    action: {
      disabled: color.disable(color.lightBlueAndDarkTurquoise).text,
      disabledBackground: color.disable(color.lightBlueAndDarkTurquoise)
        .background,
    },
  },
});

export const theme6 = createMuiTheme({
  ...defaultConfig,
  palette: {
    ...defaultConfig.palette,
    primary: {
      main: color.lightBlueAndDarkTurquoise.background,
      contrastText: color.lightBlueAndDarkTurquoise.text,
    },
    secondary: {
      main: color.yellowAndDarkTurquoise.background,
      contrastText: color.yellowAndDarkTurquoise.text,
    },
    action: {
      disabled: color.disable(color.lightBlueAndDarkTurquoise).text,
      disabledBackground: color.disable(color.lightBlueAndDarkTurquoise)
        .background,
    },
  },
});

export const theme7 = createMuiTheme({
  ...defaultConfig,
  palette: {
    ...defaultConfig.palette,
    primary: {
      main: color.coralAndLightGrey.background,
      contrastText: color.coralAndLightGrey.text,
    },
    secondary: {
      main: color.turquoiseAndLightGrey.background,
      contrastText: color.turquoiseAndLightGrey.text,
    },
    action: {
      disabled: color.disable(color.coralAndLightGrey, 1.0).text,
      disabledBackground: color.disable(color.coralAndLightGrey).background,
    },
  },
});

export const theme8 = createMuiTheme({
  ...defaultConfig,
  palette: {
    ...defaultConfig.palette,
    primary: {
      main: color.turquoiseAndLightGrey.background,
      contrastText: color.turquoiseAndLightGrey.text,
    },
    secondary: {
      main: color.coralAndLightGrey.background,
      contrastText: color.coralAndLightGrey.text,
    },
    action: {
      disabled: color.disable(color.turquoiseAndLightGrey, 1.0).text,
      disabledBackground: color.disable(color.turquoiseAndLightGrey).background,
    },
  },
});

export const theme9 = createMuiTheme({
  ...defaultConfig,
  palette: {
    ...defaultConfig.palette,
    primary: {
      main: color.turquoiseAndLightGrey.background,
      contrastText: color.turquoiseAndLightGrey.text,
    },
    secondary: {
      main: color.yellowAndLightGrey.background,
      contrastText: color.yellowAndLightGrey.text,
    },
    action: {
      disabled: color.disable(color.turquoiseAndLightGrey, 1.0).text,
      disabledBackground: color.disable(color.turquoiseAndLightGrey).background,
    },
  },
});

export default defaultTheme;
